/*
 * @Author: your name
 * @Date: 2019-09-20 14:32:17
 * @LastEditTime: 2021-03-23 16:01:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/main.js
 */

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './utils/filters'
import './fonts/iconfont.css'
import './fonts/iconfont.js'
import './styles/index.scss'
import router from './router'
import './axios'
import Storage from 'vue-ls'
import EventProxy from 'vue-event-proxy'

import { backTop } from './utils/index'

import '../../zhulogic-module/packages/styles/index.scss'
import ZhulogicModule from '../../zhulogic-module/packages/index'

import './utils/vue-uweb'

import VueKonva from 'vue-konva'

import * as vClickOutside from 'v-click-outside-x'

const options = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
}

Vue.config.productionTip = false

Vue.use(ZhulogicModule)

Vue.use(Storage, options)

Vue.use(EventProxy)

Vue.use(VueKonva)

Vue.use(vClickOutside)

// 全局 const
Vue.prototype.ossPrefix = process.env.VUE_APP_IMAGE_BASE_URL
Vue.prototype.backTop = backTop

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
